{
  "cycle.entite.plateforme_maintenance_notifications": "Platform maintenance notices and reminders",
  "cycle.entite.plateforme_maintenances": "Platform maintenance windows"
}
